/**
* 售后管理
*/
<template>
	<div style="display: flex;flex-direction: column; height: 89vh;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<!-- 第一行搜索条件 -->
		<div style="margin: 0 10px; display: flex;">

			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="设备类型" style="width: 300px;">
					<el-select v-model="form.activityRegion" clearable placeholder="请选择设备类型" @change="select">
						<!-- 1 cellmate  pearFlower  3 little devil  4 7 二代锁  6 钥匙盒  5 拍子
						9 肛塞 10三代锁 11二代钥匙盒 12尾巴 13金属锁 14脉冲鸟 15震动金属锁 16飞机杯 17三代肛塞(无加密)
						18三代肛塞(有加密)-->
						<el-option label="一代锁" value="1"></el-option>
						<el-option label="梨花肛塞" value="2"></el-option>
						<el-option label="小恶魔" value="3"></el-option>
						<el-option label="二代锁(旧图标)" value="4"></el-option>
						<el-option label="电击拍" value="5"></el-option>
						<el-option label="一代钥匙盒" value="6"></el-option>
						<el-option label="二代锁(新图标)" value="7"></el-option>
						<el-option label="二代肛塞" value="9"></el-option>
						<el-option label="三代锁" value="10"></el-option>
						<el-option label="二代钥匙盒" value="11"></el-option>
						<el-option label="尾巴" value="12"></el-option>
						<el-option label="金属锁" value="13"></el-option>
						<el-option label="脉冲鸟" value="14"></el-option>
						<el-option label="震动金属锁" value="15"></el-option>
						<el-option label="飞机杯" value="16"></el-option>
						<el-option label="三代肛塞" value="17"></el-option>
						<el-option label="三代肛塞(无加密)" value="17"></el-option>
						<el-option label="三代肛塞(有加密)" value="18"></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<el-form ref="form" label-width="80px">
				<el-form-item label="搜索时间">
					<el-date-picker v-model="value" type="daterange" @change="selectTime" start-placeholder="开始日期"
						end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
					</el-date-picker>
				</el-form-item>
			</el-form>

			<el-input style="margin-left: 15px; margin-right: 10px; height: 20px;" placeholder="请输入内容" v-model="input2"
				label-width="60px">
				<template slot="prepend">蓝牙地址</template>
			</el-input>

			<el-input style="margin-left: 15px; margin-right: 10px; height: 20px;" placeholder="请输入内容" v-model="input3"
				label-width="60px">
				<template slot="prepend">设备编码</template>
			</el-input>


		</div>

		<!-- 第二行搜索条件 -->
		<div style="margin: 0 20px; display: flex; margin-top: -10px; margin-bottom: 20px;">

			<el-input style="margin-right: 10px; height: 20px;" placeholder="请输入内容" v-model="input1" label-width="60px">
				<template slot="prepend">售后单号</template>
			</el-input>

			<el-input style="margin-left: 15px; margin-right: 10px; height: 20px;" placeholder="请输入内容" v-model="input5"
				label-width="60px">
				<template slot="prepend">用户寄出单号</template>
			</el-input>
			<el-input style="margin-left: 15px; margin-right: 10px; height: 20px;" placeholder="请输入内容" v-model="input6"
				label-width="60px">
				<template slot="prepend">售后寄出单号</template>
			</el-input>

			<el-input style="margin-left: 15px; margin-right: 10px; height: 20px;" placeholder="请输入内容" v-model="input4"
				label-width="60px">
				<template slot="prepend">用户ID</template>
			</el-input>

			<el-button style="margin-left: 5px;" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>

		</div>

		<!-- 列表 -->
		<el-table :data="tableData" height="200" stripe border style="width: 100%; flex: 1; overflow: auto;">
			<el-table-column type="index" :index="indexMethod" align="center"></el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="160" sortable></el-table-column>
			<el-table-column label="售后单号" align="center" width="240">
				<template slot-scope="scope">
					<div slot="reference" class="name-wrapper">
						<p style="font-size: 14px;">{{ scope.row.afterSaleNo }}</p>
					</div>
				</template>
			</el-table-column>

			<el-table-column prop="serialNumber" label="设备编码" align="center" width="140"></el-table-column>
			<el-table-column prop="bluetoothAddress" label="蓝牙地址" align="center" width="160"></el-table-column>
			<el-table-column prop="userId" label="用户ID" align="center" width="100"></el-table-column>
			<el-table-column prop="toyName" label="设备名称" align="center" width="160"></el-table-column>
			<el-table-column prop="typeId" label="设备类型" align="center" width="120"></el-table-column>
			<el-table-column prop="userLogisticsNo" label="用户寄出单号" align="center" width="180"></el-table-column>
			<el-table-column prop="sysLogisticsNo" label="售后寄出单号" align="center" width="180"></el-table-column>
			<el-table-column label="售后状态" align="center">
				<template slot-scope="scope">
					<div slot="reference" class="name-wrapper">
						<!-- （0 预检中 1 等待用户寄出 2 待检修 3检修中 4 检修完成 5 预检通过 6 预检未通过) -->
						<p v-show="scope.row.afterSaleStatus==0" style="font-size: 14px; color: #0000FF;">预检中</p>
						<p v-show="scope.row.afterSaleStatus==1" style="font-size: 14px; color: #FFA500;">等待用户寄出</p>
						<p v-show="scope.row.afterSaleStatus==2" style="font-size: 14px; color: #808080;">待检修</p>
						<p v-show="scope.row.afterSaleStatus==3" style="font-size: 14px; color: #800080;">检修中</p>
						<p v-show="scope.row.afterSaleStatus==4" style="font-size: 14px; color: #008000;">检修完成</p>
						<p v-show="scope.row.afterSaleStatus==5" style="font-size: 14px; color: #008080;">预检通过</p>
						<p v-show="scope.row.afterSaleStatus==6" style="font-size: 14px; color: #FF0000;">预检未通过</p>
					</div>
				</template>
			</el-table-column>

			<el-table-column fixed="right" label="操作" width="100" align="center">
				<template slot-scope="scope">
					<el-button @click="querySimCard(scope.$index)" type="text" size="small">查看详情</el-button>
				</template>
			</el-table-column>

		</el-table>

		<!-- 页码 -->
		<div class="block"
			style="flex-shrink: 0; width: 100%; height: 60px; display: flex; align-items: center; justify-content: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[20, 30, 40,50,100,200]" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				form: {
					activityRegion: '', // 根据需要添加其他表单字段
				},
				typeId: 0, //设备类型
				value: '', //时间
				startTime: 0, //开始时间
				endTime: 0, //结束时间
				input1: '', //售后单号
				input2: '', //蓝牙地址
				input3: '', //设备序列号
				input4: '', //用户ID
				input5: '', //用户寄出单号
				input6: '', //售后寄出单号
				pageSize: 20, //每页条数
				pageNum: 1, //当前页数
				total: 0, //一共有多少条数据
				tableData: null, //列表数据
				//...
			};
		},
		mounted() {
			this.fetchData(this.pageNum, this.pageSize); //售后单分页数据
		},
		methods: {
			fetchData(pageNum, pageSize) { //售后单分页数据
				this.loadingData = true;

				this.pageSize = pageSize;
				this.pageNum = pageNum;

				const requestData = {}; //传递的参数
				requestData.pageSize = pageSize;
				requestData.pageNum = pageNum;

				if (this.typeId != 0) {
					requestData.typeId = this.typeId; //设备类型
				}

				if (this.startTime != 0) {
					requestData.startTime = this.startTime; //开始时间
				}
				if (this.endTime != 0) {
					requestData.endTime = this.endTime; //结束时间
				}

				if (this.input1.length > 0) { //售后单号
					requestData.afterSaleNo = this.input1;
				}
				if (this.input2.length > 0) { //蓝牙地址
					requestData.bluetoothAddress = this.input2;
				}
				if (this.input3.length > 0) { //设备序列号
					requestData.serialNumber = this.input3;
				}
				if (this.input4.length > 0) { //用户ID
					requestData.userId = this.input4;
				}
				if (this.input5.length > 0) { //用户寄出单号
					requestData.userLogisticsNo = this.input5;
				}
				if (this.input6.length > 0) { //售后寄出单号
					requestData.sysLogisticsNo = this.input6;
				}
				// if (this.input7.length > 0) { //IP地址
				// 	requestData.ip = this.input7;
				// }
				// if (this.input8.length > 0) { //IP所属地
				// 	requestData.address = this.input8;
				// }
				// if (this.startTime > 0) { //开始时间
				// 	requestData.startTime = this.startTime;
				// }
				// if (this.endTime > 0) { //结束时间
				// 	requestData.endTime = this.endTime;
				// }

				console.log("售后单分页数据  发送的数据：", requestData)

				axios.post(this.$p_url + '/afterSale/H5/getH5SysRecordAfterSaleRecordList', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("售后单分页数据  后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "authFailed") { //登录失效
							Cookies.remove("token");
							this.$router.push({ //跳转到登录
								path: '/Login1715',
								query: {}
							});
						}
						if (state === "success") { // 检查状态
							this.total = response.data.data.total; //一共有多少条数据
							for (let i = 0; i < response.data.data.list.length; i++) {
								//修改设备类型 1 cellmate  pearFlower  3 little devil  4 7 二代锁  6 钥匙盒  5 拍子  9 肛塞 10三代锁 12尾巴 13金属锁
								switch (response.data.data.list[i].typeId) {
									case 1:
										response.data.data.list[i].typeId = "一代锁";
										break
									case 2:
										response.data.data.list[i].typeId = "梨花肛塞";
										break
									case 3:
										response.data.data.list[i].typeId = "小恶魔";
										break
									case 4:
										response.data.data.list[i].typeId = "二代锁(旧标)";
										break
									case 5:
										response.data.data.list[i].typeId = "电击拍";
										break
									case 6:
										response.data.data.list[i].typeId = "一代钥匙盒";
										break
									case 7:
										response.data.data.list[i].typeId = "二代锁(新标)";
										break
									case 9:
										response.data.data.list[i].typeId = "二代肛塞";
										break
									case 10:
										response.data.data.list[i].typeId = "三代锁";
										break
									case 11:
										response.data.data.list[i].typeId = "二代钥匙盒";
										break
									case 12:
										response.data.data.list[i].typeId = "尾巴";
										break
									case 13:
										response.data.data.list[i].typeId = "金属锁";
										break
									case 14:
										response.data.data.list[i].typeId = "脉冲鸟";
										break
									case 15:
										response.data.data.list[i].typeId = "震动金属锁";
										break
									case 16:
										response.data.data.list[i].typeId = "飞机杯";
										break
									case 17:
										response.data.data.list[i].typeId = "三代肛塞(无加密)";
										break
									case 18:
										response.data.data.list[i].typeId = "三代肛塞(有加密)";
										break
								}

							}
							this.tableData = response.data.data.list;
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			querySimCard(index) { //查看详情
				let page = this.$router.resolve({
					path: '/AfterSalesInfo',
					query: {
						id: this.tableData[index].id,
					}
				});
				window.open(page.href, '_blank');
			},
			search() { //单击了搜索
				this.fetchData(1, this.pageSize);
			},
			select() { //选中了某个值
				this.typeId = this.form.activityRegion;
				this.fetchData(1, this.pageSize);
			},
			selectTime() { //选择了时间
				if (this.value == null) {
					this.startTime = 0;
					this.endTime = 0;
					this.fetchData(1, this.pageSize);
				} else {
					[this.startTime, this.endTime] = this.value;
					// 将时间字符串转换为时间戳
					this.startTime = new Date(this.startTime).getTime();
					this.endTime = new Date(this.endTime).getTime();
					this.fetchData(1, this.pageSize);
				}
			},
			handleSizeChange(val) { //设置每页多少条
				this.pageSize = val;
				this.fetchData(this.pageNum, val);
			},
			handleCurrentChange(val) { //查询第几页的数据
				this.fetchData(val, this.pageSize);
			},
			indexMethod(index) {
				if (this.pageNum == 1) {
					return index + 1;
				} else {
					return (this.pageNum - 1) * this.pageSize + index + 1;
				}

			},
			//...
		}
		//...
	}
</script>

<style>
</style>